import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3>Gener8ions Church</h3>
          <p>Trust | Love | Understand</p>
          <p>To build relationships of trust, share the love of God, and understand generations.</p>
        </div>

        <div className="footer-section">
          <h4>Quick Links</h4>
          <Link to="/">Home</Link>
          <Link to="/about">Who We Are</Link>
          <Link to="/sermons">Sermons</Link>
          <Link to="/services">Services</Link>
        </div>

        <div className="footer-section">
          <h4>Contact</h4>
          <p>9644 Maumelle Blvd</p>
          <p>North Little Rock, AR 72113</p>
          <p>Phone: (501) 353-0651</p>
          <p>Email: admin@gener8ionschurchonline.org</p>
        </div>

        <div className="footer-section">
          <h4>Service Times</h4>
          <p><strong>Sunday:</strong></p>
          <p>Corporate Prayer: 8:00 AM</p>
          <p>Worship & The Word: 9:00 AM</p>
          <p><strong>Wednesday:</strong></p>
          <p>Corporate Prayer: 6:00 PM</p>
          <p>JLABS: 7:00 PM - 8:15 PM</p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Gener8ions Church. All rights reserved.</p>
        <p className="footer-powered-by">
          Powered by{' '}
          <a
            href="https://jagoalt.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            JagoAlt
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;

